import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32aa9925"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginpanel" }
const _hoisted_2 = {
  key: 0,
  class: "invitation"
}
const _hoisted_3 = { class: "invitation__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Invitation reçue", -1))
const _hoisted_5 = { class: "invitation__actions" }
const _hoisted_6 = {
  key: 1,
  class: "invitation"
}
const _hoisted_7 = { class: "invitation__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "En attente de réponse", -1))
const _hoisted_9 = { class: "invitation__actions" }
const _hoisted_10 = {
  key: 2,
  class: "login-pseudo-zone"
}
const _hoisted_11 = {
  key: 0,
  class: "login-pseudo-zone__input align-left"
}
const _hoisted_12 = { class: "pseudo-input-line" }
const _hoisted_13 = {
  key: 1,
  class: "login-pseudo-zone__welcome-cartouche align-left"
}
const _hoisted_14 = { class: "mode-bar" }
const _hoisted_15 = { class: "opp-games-panel align-left" }
const _hoisted_16 = { class: "list-opp" }
const _hoisted_17 = {
  key: 0,
  class: "empty-list-opp"
}
const _hoisted_18 = { class: "opp-games-panel align-left" }
const _hoisted_19 = { class: "list-opp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectableOpp = _resolveComponent("SelectableOpp")!
  const _component_SelectableGame = _resolveComponent("SelectableGame")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lobbyState.invitation.value.receiving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h3", null, _toDisplayString(_ctx.lobbyState.invitation.value.receiving) + " souhaite vous lancer un défi.", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "invitation__action",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptInvite && _ctx.acceptInvite(...args)))
              }, "Accepter"),
              _createElementVNode("div", {
                class: "invitation__action",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refuseInvite && _ctx.refuseInvite(...args)))
              }, "Refuser")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.lobbyState.invitation.value.sending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h3", null, _toDisplayString(_ctx.lobbyState.invitation.value.sending) + " considère votre demande de duel.", 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "invitation__action",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelInvite && _ctx.cancelInvite(...args)))
              }, "Annuler")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (!_ctx.pseudo_validated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  style: _normalizeStyle({visibility: _ctx.pseudoTaken || _ctx.pseudoTooShort ? 'visible' : 'hidden'}),
                  class: "error-message"
                }, _toDisplayString(_ctx.pseudoProblemText), 5),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    class: "pseudo-input",
                    type: "text",
                    autofocus: "",
                    placeholder: "Pseudo",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.current_pseudo) = $event)),
                    onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendPseudo && _ctx.sendPseudo(...args)), ["enter"])),
                    maxlength: "15/"
                  }, null, 544), [
                    [_vModelText, _ctx.current_pseudo]
                  ]),
                  _createElementVNode("div", {
                    class: "send-pseudo-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendPseudo && _ctx.sendPseudo(...args)))
                  }, "Valider")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", null, "Bienvenue " + _toDisplayString(_ctx.player_pseudo), 1)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: _normalizeClass([{
        'mode-btn--selected': _ctx.lobbyState.panel.value === 'select-opp',
        'mode-btn--not-selected': _ctx.lobbyState.panel.value === 'spectate'
      }, "mode-btn mode-btn-play"]),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.switchPanelState && _ctx.switchPanelState(...args)))
      }, "Affronter un adversaire", 2),
      _createElementVNode("div", {
        class: _normalizeClass([{
        'mode-btn--not-selected': _ctx.lobbyState.panel.value === 'select-opp',
        'mode-btn--selected': _ctx.lobbyState.panel.value === 'spectate'
      }, "mode-btn mode-btn-spec"]),
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.switchPanelState && _ctx.switchPanelState(...args)))
      }, "Regarder une partie", 2)
    ]),
    (_ctx.lobbyState.panel.value === 'select-opp')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.lobbyState.listOpp.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, "En attente de nouveaux adversaires"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lobbyState.listOpp.value, (opp) => {
                return (_openBlock(), _createBlock(_component_SelectableOpp, {
                  opponent: opp,
                  key: opp
                }, null, 8, ["opponent"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({visibility: _ctx.player_pseudo !== '' ? 'visible' : 'hidden'})
          }, [
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validOpp && _ctx.validOpp(...args))),
              class: _normalizeClass(["valid-btn", {unclickable: !_ctx.opponentSelected}])
            }, "C'est parti !", 2)
          ], 4)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.lobbyState.panel.value === 'spectate')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lobbyState.listGamesToSpectate.value, (game) => {
                return (_openBlock(), _createBlock(_component_SelectableGame, {
                  game: game,
                  key: game
                }, null, 8, ["game"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({visibility: _ctx.player_pseudo !== '' ? 'visible' : 'hidden'})
          }, [
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validGameToSpectate && _ctx.validGameToSpectate(...args))),
              class: _normalizeClass(["valid-btn", {unclickable: !_ctx.gameSelected}])
            }, "C'est parti !", 2)
          ], 4)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}